// جلسات دعم سوقنا والإعلانات والصيانة (المواصفات 31).
const platformAr = {
  "support.title": "وصول فريق دعم سوقنا",
  "support.description": "اسمح لفريق دعم سوقنا بالاطلاع على متجرك عندما تطلب المساعدة. تحتاج كل زيارة إلى تذكرة دعم، ولا تتجاوز 30 دقيقة، وتكون للعرض فقط ما لم توافق على إجراء تغييرات، وتظهر في سجل نشاطك.",
  "support.allowed_now": "مسموح",
  "support.denied_now": "غير مسموح",
  "support.setting.default": "تلقائي",
  "support.setting.default_hint": "مسموح خلال الفترة التجريبية المجانية، ثم يتوقف.",
  "support.setting.allowed": "السماح دائماً",
  "support.setting.allowed_hint": "يستطيع الدعم فتح جلسة متى كانت لديك تذكرة لدينا.",
  "support.setting.denied": "عدم السماح",
  "support.setting.denied_hint": "لا يستطيع الدعم فتح متجرك حتى مع وجود تذكرة. إيقاف هذا ينهي أي جلسة جارية.",
  "support.owner_only": "مالك المتجر وحده يستطيع تغيير هذا.",
  "support.banner": "يطّلع دعم سوقنا ({operator}) على هذا المتجر",
  "support.mode_read": "للعرض فقط",
  "support.mode_write": "التغييرات مسموحة",
  "support.ends_in": "{minutes, plural, =0 {تنتهي الآن} zero {تنتهي الآن} one {تنتهي خلال دقيقة} two {تنتهي خلال دقيقتين} few {تنتهي خلال # دقائق} many {تنتهي خلال # دقيقة} other {تنتهي خلال # دقيقة}}",
  "platform.maintenance": "سوقنا قيد الصيانة. التغييرات متوقفة لبضع دقائق، ويمكنك متابعة التصفح.",
  "platform.learn_more": "اعرف المزيد",
  "platform.dismiss": "إخفاء",
  "platform.news": "أخبار سوقنا",
};

export default platformAr;
